/*
    Copyright 2022-2025, Techwise Integrated Security, LLC
*/

import Box from "@mui/material/Box";
import { TextField } from "@mui/material";
import React from "react";
import { Setter } from "../../utils/Interfaces";

export interface UncontrolledEditableFieldProps {
    value: string;
    label: string;
    editing: boolean;
    setter: Setter<string>;
    error?: boolean;
}

export const UncontrolledEditableField = (props: UncontrolledEditableFieldProps) => {
    const { value, label, editing, setter, error = false } = props;

    const key: string = label.toLowerCase().replaceAll(" ", "_");

    return (
        <Box>
            <TextField
                onChange={(event) => {
                    setter(event.target.value);
                }}
                margin="normal"
                required
                fullWidth
                id={key}
                label={label}
                name={key}
                value={value}
                size="small"
                sx={{
                    m: 0.75,
                    ml: 0,
                }}
                disabled={!editing}
                error={error}
            />
        </Box>
    );
};
